import { useContext, useEffect, useState } from "react";
import IndieStaticSelect from "../IndieStaticSelect";
import { Skeleton } from "@mui/material";
import { TariffsContext } from "contexts/tariffs/TariffsContext";
import { useTranslation } from "react-i18next";

const IndieReceiptTermsSelect = ({agent, ...params}) => {

    const [receiptTerms, setReceiptTerms] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getReceiptTerms, getAgentReceiptTerms } = useContext(TariffsContext);
    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);
        if(agent) {
            getAgentReceiptTerms(agent.id || agent).then((response) => {
                setReceiptTerms(response.data.map((item) => ({
                    value: item.id,
                    label: item.description
                })));
                setLoading(false);
            }).catch((error) => {
                console.error(error);
                setLoading(false);
            });
        } else {
            getReceiptTerms().then((response) => {
                const _data = response.data || response;
                setReceiptTerms(_data.map((item) => ({
                    value: item.id,
                    label: item.description
                })));
                setLoading(false);
            }).catch((error) => {
                console.error(error);
                setLoading(false);
            });
        }
    }, []);

    if(loading) {
        return <Skeleton variant="rectangular" height={56} />
    }

    return (
        <IndieStaticSelect
            {...params}
            options={receiptTerms}
            label={params.label ? params.label : t("label.form.receiptTerms")}
            sx={{width: 250}}
        />
    )
}

export default IndieReceiptTermsSelect;